import { type Dispatch, type SetStateAction, useCallback, useRef, useState } from 'react'

// Like a useState but with a ref
export function useStateRef<T>(
  initialValue: T
): [T, Dispatch<SetStateAction<T>>, React.MutableRefObject<T>] {
  const [value, setValue] = useState(initialValue)
  const ref = useRef(value)

  const customSetValue: Dispatch<SetStateAction<T>> = useCallback(
    givenValue => {
      let newValue: T
      if (typeof givenValue === 'function') {
        // @ts-expect-error: Bad typings from upstream?
        newValue = givenValue(ref.current)
      } else {
        newValue = givenValue
      }
      setValue(newValue)
      ref.current = newValue
    },
    [ref]
  )

  return [value, customSetValue, ref] as const
}
